import { AssistentItem, checkEnergiedatenAuswahl, getScope3number } from './assistent_config';
import { DataService } from '../../../services/data_service';
import { getAssistentConfigBWL } from './items/assistent_config_bwl';
import { getAssistentConfigCO2 } from './items/assistent_config_co2';
import { getAssistentConfigCO2Scope3, getAssistentConfigCO2Scope3Item } from './items/assistent_config_co2scope3';
import { getAssistentConfigCfmMotivation } from './items/assistent_config_cfm_motivation';
import { getAssistentConfigEingangsHinweise, getAssistentConfigCustom } from './items/assistent_config_hinweise';
import { getAssistentConfigHinweisSachanlagen } from './items/assistent_config_hinweise_sachanlagen';
import { getAssistentConfigKonfig } from './items/assistent_config_config';
import { getAssistentConfigKraftstoffe } from './items/assistent_config_kraftstoffe';
import { getAssistentConfigSonstige } from './items/assistent_config_sonstige_daten';
import { getAssistentConfigStandorte } from './items/assistent_config_standorte';
import { getAssistentConfigStrom, getAssistentConfigEigenStrom } from './items/assistent_config_strom';
import { getAssistentConfigUnternehmen } from './items/assistent_config_unternehmensdaten';
import { getAssistentConfigVeranstaltungen } from './items/assistent_config_veranstaltungen';
import { getAssistentConfigWaerme } from './items/assistent_config_waerme';
import { getCO2Scope3Auswahl } from '../functions/getCO2Scope3Auswahl';
import { getSachanlagenStructure } from '../functions/getEnergiedatenStructure';
import { IDs } from '../../../helpers/IDs';
import { isEnableCO2, isEnableErneuerbareEnergien, isEnableGHG, isEnableSachanlagen, isEnableStandorte, isEnableVeranstaltungen } from './assistent_helpers';
import { TriggerService } from '../../../core/trigger/trigger_service';

export function getAssistentConfigCfm(
    standort: any, data: any, jahr: number, dataService: DataService, triggerService: TriggerService,
    onRoutingChange: (routing: any) => void, clearPruefState: () => void, isAdmin: boolean, bereichKey: string, routing: any
) {
    const konfiguration: any[] = (data || {})[IDs.ENT_KONFIGURATION] || [];
    const co2_fussabdruck: number = (konfiguration[0] || {}).co2_fussabdruck_orig;
    const enableErneuerbareEnergien: boolean = isEnableErneuerbareEnergien(konfiguration);
    const enableStandorte: boolean = isEnableStandorte(konfiguration);
    const enableVeranstaltungen: boolean = isEnableVeranstaltungen(konfiguration);
    const enableCO2: boolean = isEnableCO2(konfiguration);
    const enableSachanlagen: boolean = isEnableSachanlagen(konfiguration);
    const enableGHG: boolean = isEnableGHG(konfiguration);
    const modul: string = (data || {}).MODUL_SELECTED || null;

    const config: AssistentItem[] = [];
    const ignoreScopes: string[] = ['brennstoff'];

    // 1. Allgemeine Unternehmensangaben
    config.push(getAssistentConfigCfmMotivation(data, standort, jahr));
    config.push(getAssistentConfigKonfig(data, onRoutingChange, isAdmin, bereichKey, { gliederung: '1.2' }));
    config.push(getAssistentConfigUnternehmen(data, triggerService, { gliederung: '1.3' }));
    if (enableStandorte) {
        config.push(getAssistentConfigStandorte(data, dataService, triggerService, { gliederung: '1.4' }));
    }
    if (enableVeranstaltungen) {
        config.push(getAssistentConfigVeranstaltungen(data, dataService, triggerService, { gliederung: '1.5' }));
    }

    // 2. Datenerfassung Scope 1 + 2
    config.push(getAssistentConfigEingangsHinweise(data, { gliederung: '2.', name: 'Datenerfassung Scope 1 + 2' }));
    config.push(getAssistentConfigStrom(standort, data, jahr, triggerService));
    if (enableErneuerbareEnergien) {
        config.push(getAssistentConfigEigenStrom(standort, data));
    }
    config.push(getAssistentConfigWaerme(standort, data, jahr, triggerService));
    config.push(getAssistentConfigKraftstoffe(standort, data, jahr, triggerService));
    config.push(getAssistentConfigCO2({ gliederung: '2.4', style: { marginLeft: 18 } }));
    if (/*enableCO2 && */enableSachanlagen && enableGHG) {
        config.push(getAssistentConfigHinweisSachanlagen(standort, data, jahr, { gliederung: '2.5' }));
        if (standort) {
            const structSachanlagen = getSachanlagenStructure();
            structSachanlagen.forEach((s: any) => {
                if (checkEnergiedatenAuswahl(data, standort.tid, jahr, s)) {
                    config.push(s.getItemAssistentConfig(data, triggerService));
                }
            });
        }
    }

    // 3. Datenerfassung Scope 3
    config.push(getAssistentConfigCO2Scope3(
        standort, data, jahr, {
        gliederung: '3.',
        name: 'Datenerfassung Scope 3',
        colBg: null,
        ...(co2_fussabdruck !== 1 &&
            { customElements: [], infoTextKey: 'Geführter Modus - Hinweis Datenerfassung Scope 3', style: { color: '#aaa' } }
        )
    }
    ));
    if (standort) {
        const hasEmittenten: boolean = (data || {})[IDs.ENT_CO2_SCOPE3_EMITTENTEN].some((emittent: any) =>
            emittent.jahr === jahr && (emittent.standort_tid_orig || emittent.standort_tid) === standort.tid
        );
        const scope3Auswahl = getCO2Scope3Auswahl(data, standort, jahr, jahr).sort((a: string, b: string) => {
            return getScope3number(a, bereichKey, modul) - getScope3number(b, bereichKey, modul);
        });
        scope3Auswahl.forEach((scope: string) => {
            if (ignoreScopes.indexOf(scope) !== -1 || (scope === 'emittenten' && !hasEmittenten)) {
                return;
            }
            const item_subscope = getAssistentConfigCO2Scope3Item(scope, data, triggerService, bereichKey, modul);
            if (item_subscope) {
                config.push(item_subscope);
            }
        });
    }

    // 4. Weitere Daten
    config.push(getAssistentConfigCustom(data, { gliederung: '4.', name: 'Weitere Daten' }, 'hinweis_cfm_weitere_daten'));
    config.push(getAssistentConfigBWL(data, { gliederung: '4.1', name: 'Betriebswirtschaftliche Daten', style: { marginLeft: 18 } }));
    config.push(getAssistentConfigSonstige({ gliederung: '4.2', style: { marginLeft: 18 } }));

    return config;
}
